import commonUtilities from "utilities/common";

function getLeadNumber() {
    const segments = window.location.pathname.split("/");
    if(segments) {
        const index = segments.findIndex(
            item => item.toLowerCase() === "lead"
        );
        if(index > -1 && segments.length > index + 1) {
            return segments[index + 1];
        }
    }
    return null;
}

async function executeQuery(endpoint, config) {
    try {
        const response = await fetch(endpoint, config);
        // proceed status: 200
        const contentType = response.headers.get("Content-Type") || "";
        if (response.ok) {
            if(contentType === "application/pdf") {
                // pdf
                const reader = response.body.getReader();
                const chunks = [];

                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    chunks.push(value); // Uint8Array
                }
                return {
                    statusCode: response.status,
                    pdfContent: chunks
                };
            }
            else {
                // otherwise return json
                return await response.json();
            }
        }
        else {
            if(contentType.includes("application/json")) {
                return await response.json();
            }
        }
        return Promise.resolve(response);

    } catch (err) {
        return Promise.reject(err.message || "Request failed");
    }
}

export async function client(endpoint, { body, method = "GET", ...customConfig } = {}) {
    const tokenResponse = await commonUtilities.getOktaToken();
    const accessToken = tokenResponse?.accessToken;

    const headers = {
        Authorization: accessToken ? `Bearer ${accessToken}` : "",
        "Content-Type": "application/json",
        "Lead-Number": getLeadNumber(),
        ...customConfig.headers // allow override
    };

    const config = {
        method,
        headers,
        ...customConfig
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    return executeQuery(endpoint, config);
}

// Convenience methods
client.get = (endpoint, customConfig = {}) =>
    client(endpoint, { ...customConfig, method: "GET" });

client.post = (endpoint, body, customConfig = {}) =>
    client(endpoint, { ...customConfig, method: "POST", body });

client.put = (endpoint, body, customConfig = {}) =>
    client(endpoint, { ...customConfig, method: "PUT", body });

export default client;
